import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslationModule } from '@app/app-translation.module';
import { ImportClientsMobilePage } from './mobile/import-clients.mobile.page';
import { ImportClientsDesktopPage } from './desktop/import-clients.desktop.page';
import { ImportClientsPage } from './import-clients.page';
import { PageHeaderComponentModule } from '@shared-components/page-header-component/page-header.component.module';
import { PipesModule } from '@shared-pipes/pipes.module';
import { DirectivesModule } from '@shared-directives/directives.module';
import { MobileBlockerComponentModule } from '@internal/gui/structural-components/mobile-blocker-component/mobile-blocker-component.module';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		RouterModule.forChild([
			{
				path: '',
				component: ImportClientsPage,
			},
		]),
		TranslationModule,
		PageHeaderComponentModule,
		PipesModule,
		DirectivesModule,
		MobileBlockerComponentModule,
	],
	declarations: [ImportClientsPage, ImportClientsMobilePage, ImportClientsDesktopPage],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ImportClientsPageModule {}
